import { useContext } from 'react';
import { RevisionContext } from '../contexts/RevisionContext';
import type { ProjectDashboardRevision } from '../projectDashboardTypes';

const useRevision = (): ProjectDashboardRevision => {
  const revision = useContext(RevisionContext);
  if (!revision) {
    throw new Error('useRevision must be used within a RevisionProvider');
  }
  return revision;
};

export default useRevision;
